module.exports = __webpack_public_path__ + "img/antes_despues_58.56127228.png";